// src/redux/memberApi.js
import { apiSlice } from "./apiSlice";

export const memberApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getMyInfo: build.query({
            query: () => ({
                url: "/api/user/member/v1/me",
                method: "get",
                headers: { token: true },
            }),
        }),
        updateMyInfo: build.mutation({
            query: (data) => ({
                url: "/api/user/member/v1",
                method: "put",
                headers: { token: true },
                body: data,
            }),
        }),
        updateFcmToken: build.mutation({
            query: (token) => ({
                url: "/api/user/member/v1/fcm/token",
                method: "put",
                headers: { token: true },
                body: { fcmToken: token },
            }),
        }),
        changePassword: build.mutation({
            query: (data) => ({
                url: "/api/user/member/v1/password",
                method: "put",
                headers: { token: true },
                body: data,
            }),
        }),
    }),
});

export const { 
    useGetMyInfoQuery,
    useUpdateMyInfoMutation,
    useUpdateFcmTokenMutation,
    useChangePasswordMutation
} = memberApi;
